export default "__VITE_ASSET__BvDWP7fv__"